import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../constants/ActionNameConstants';
import { CGA_FILES_LIST_API_URL } from '../../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../../features/axiosClient';
import { cgaFilesFailure, cgaFilesSuccess } from '../actions';

const cgaFilesAPI = (action) => postApiRequest(CGA_FILES_LIST_API_URL, action);

function* handleCGAFilesAPI(action) {
  try {
    const response = yield call(cgaFilesAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(cgaFilesSuccess(response));
  } catch (error) {
    yield put(cgaFilesFailure(error));
  }
}

export function* watchCGAFilesList() {
  yield takeLatest(types.GET_CGA_FILES_LIST_REQUEST, handleCGAFilesAPI);
}
